import React from "react";
import useDevice from "../../helper/custom-hook/useDevice";
import User from "../other-icons/User";

import "./my-account-button.m.css";

function MyAccountButton({ onAccountHandler }) {
  const isMobile = useDevice();
  return (
    <div styleName="myaccount-wrapper" onClick={onAccountHandler}>
      <button target="_blank">
        {isMobile ? (
          <span styleName="user-wrapper">
            <User color="white" height="16px" width="16px" />
          </span>
        ) : (
          <span styleName="acc-desk">
            <User color="black" height="16px" width="16px" />
          </span>
        )}

        <span>{!isMobile && "Account"}</span>
      </button>
    </div>
  );
}

export default MyAccountButton;
